const MOBILE_BREAKPOINT_PX = 640;

export function createPreviewInteractionTooltip(text: string, iconSrc: string): HTMLDivElement {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT_PX;

  const tooltip = document.createElement('div');
  tooltip.className = 'preview-expand-tooltip';
  tooltip.style.cssText = `
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: ${isMobile ? 'min(172px, calc(100% - 24px))' : 'min(231px, calc(100% - 24px))'};
    height: ${isMobile ? '44px' : '60px'};
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    z-index: 75;
    opacity: 0;
    transition: opacity 200ms ease-out;
    pointer-events: none;
    user-select: none;
    box-sizing: border-box;
    overflow: hidden;
  `;

  const leftAccent = document.createElement('div');
  leftAccent.style.cssText = `
    position: absolute;
    left: 0;
    top: 0;
    width: 2px;
    height: 100%;
    background: #FFDD15;
  `;

  const rightAccent = document.createElement('div');
  rightAccent.style.cssText = `
    position: absolute;
    right: 0;
    top: 0;
    width: 2px;
    height: 100%;
    background: #FFDD15;
  `;

  const content = document.createElement('div');
  content.style.cssText = `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
  `;

  const iconArea = document.createElement('div');
  iconArea.style.cssText = `
    position: relative;
    width: ${isMobile ? '48px' : '60px'};
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const divider = document.createElement('div');
  divider.style.cssText = `
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.5px;
    height: ${isMobile ? '30px' : '39px'};
    background: rgba(255, 255, 255, 0.2);
  `;

  const icon = document.createElement('img');
  icon.src = iconSrc;
  icon.alt = '';
  icon.setAttribute('aria-hidden', 'true');
  icon.style.cssText = `
    width: ${isMobile ? '22px' : '31px'};
    height: ${isMobile ? '30px' : '42.17px'};
    display: block;
  `;

  const labelArea = document.createElement('div');
  labelArea.style.cssText = `
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 ${isMobile ? '8px' : '10px'};
  `;

  const label = document.createElement('div');
  label.textContent = text;
  label.style.cssText = `
    color: #FFFFFF;
    font-family: Poppins, sans-serif;
    font-weight: 400;
    font-size: ${isMobile ? '10px' : '16px'};
    line-height: 1.1;
    text-align: left;
    width: 100%;
  `;

  tooltip.appendChild(leftAccent);
  tooltip.appendChild(rightAccent);
  iconArea.appendChild(icon);
  iconArea.appendChild(divider);
  labelArea.appendChild(label);
  content.appendChild(iconArea);
  content.appendChild(labelArea);
  tooltip.appendChild(content);

  return tooltip;
}
